/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {findCustomers} from '../api'

 export const useQueryFindCustomers = createReactQueryHook('findCustomers', findCustomers)
